const state = {

    userList: [],
    userList2: [
        {
            company: {
                name: 'DSM8',
                additional_address: '',
                street: 'Leipziger Platz 1',
                plz: '12234',
                city: 'Berlin'
            },
            name: {
                firstname: 'Holger',
                lastname: 'Schmidt',
                email: 'asfadsf@asdfdsf.de',
                telephone: '12234',
                salutation: 1,
                salutation_str: 'Herr'
            },
            main_categories: [
                {
                    main_category_id: 1,
                    main_category: 'Indoor'
                },
                {
                    main_category_id: 2,
                    main_category: 'Outdoor'
                }
            ],
            sub_categories: [
                {
                    sub_category_id: 1,
                    sub_category: 'Bühne'
                },
                {
                    sub_category_id: 2,
                    sub_category: 'Sightseeing'
                }
            ],
            type: 'Admin',
            type_id: 1,
            status: 1,
            last_login: '22.02.2022',
            last_insert: '22.02.2022',
            user_id: 8,
            edit: 1
        },
        {
            company: {
                name: 'Banane',
                additional_address: '',
                street: 'Leipziger Platz 1',
                plz: '12234',
                city: 'Berlin'
            },
            name: {
                firstname: 'Holger',
                lastname: 'Schmidt',
                email: 'asfadsf@asdfdsf.de',
                telephone: '12234',
                salutation: 1,
                salutation_str: 'Herr'
            },
            main_categories: [
                {
                    main_category_id: 1,
                    main_category: 'Indoor'
                },
                {
                    main_category_id: 2,
                    main_category: 'Outdoor'
                }
            ],
            sub_categories: [
                {
                    sub_category_id: 1,
                    sub_category: 'Bühne'
                },
                {
                    sub_category_id: 2,
                    sub_category: 'Sightseeing'
                }
            ],
            type: 'Admin',
            type_id: 1,
            status: 1,
            last_login: '22.02.2022',
            last_insert: '22.02.2022',
            user_id: 6,
            edit: 1
        },
        {
            company: {
                name: 'xxx',
                additional_address: '',
                street: 'Leipziger Platz 1',
                plz: '12234',
                city: 'Berlin'
            },
            name: {
                firstname: 'Holger',
                lastname: 'Schmidt',
                email: 'asfadsf@asdfdsf.de',
                telephone: '12234',
                salutation: 1,
                salutation_str: 'Herr'
            },
            main_categories: [
                {
                    main_category_id: 1,
                    main_category: 'Indoor'
                },
                {
                    main_category_id: 2,
                    main_category: 'Outdoor'
                }
            ],
            sub_categories: [
                {
                    sub_category_id: 1,
                    sub_category: 'Bühne'
                },
                {
                    sub_category_id: 2,
                    sub_category: 'Sightseeing'
                }
            ],
            type: 'Admin',
            type_id: 1,
            status: 1,
            last_login: '22.02.2022',
            last_insert: '22.02.2022',
            user_id: 2,
            edit: 1
        },
    ],
    main_categories: [
        {
            main_category_id: 1,
            main_category: 'Indoor',
            active: false,
        },
        {
            main_category_id: 2,
            main_category: 'Outdoor',
            active: false,
        }
    ],
    sub_categories: [
        {
            sub_category_id: 3,
            sub_category: 'Bühne',
            active: false,
        },
        {
            sub_category_id: 4,
            sub_category: 'Sightseeing',
            active: false,
        },
        {
            sub_category_id: 5,
            sub_category: 'Museen/Ausstellungen',
            active: false,
        },
        {
            sub_category_id: 6,
            sub_category: 'Freizeit',
            active: false,
        }
    ],
    recordingDates: {},
    recordingYears: {},
    recordingMonths: {},
    recordingStartDate: '',
    recordingEndDate: '',
    records: {},
    statisticFilterButtons: {},
}

const mutations = {
    SET_NEW_USER(state, payload) {
        //console.log('setze Monat: ' + payload);

        if (payload.index < 0) {

            state.userList.push(payload.user);
            console.log(state.userList);
            return;
        }

        state.userList[payload.index] = payload.user;
    },

    SET_RECORDING_DATES(state, payload) {
        state.recordingDates = payload;
    },
    SET_RECORDING_START_DATE(state, payload) {
        state.recordingStartDate = payload;
    },
    SET_RECORDING_END_DATE(state, payload) {
        state.recordingEndDate = payload;
    },
    SET_RECORDS(state, payload) {
        state.records = payload;
    },
    SET_USERLIST(state, payload) {
        state.userList = payload;
    },
    SET_RECORDING_MONTHS(state, payload) {
        state.recordingMonths = payload;
    },

    SET_CATEGORY_ACTIVE(state, payload) {

        var type = payload.type;
        var category_id = payload.category_id;
        var active = payload.active;
        let data = {};
        var key = '';
        var idname = '';

        if (type == 'main') {
            data = state.main_categories;
            key = 'main_categories';
            idname = 'main_category_id';
        } else {
            data = state.sub_categories;
            key = 'sub_categories';
            idname = 'sub_category_id';
        }

        console.log(category_id, idname, data);

        Object.keys(data).forEach(el => {
            console.log(el, data[el][idname]);

            if (data[el][idname] === category_id) {
                state[key][el].active = active;
            }
        });

    },

    SET_STATISTIC_FILTER_BUTTONS(state, payload) {
        state.statisticFilterButtons = payload;
    },
}

const actions = {

    setNewUser({commit}, payload) {
        commit('SET_NEW_USER', payload);
    },

    setRecordingDates({commit}, payload) {
        commit('SET_RECORDING_DATES', payload);
    },

    setRecordingStartDate({commit}, payload) {
        //console.log(payload);
        commit('SET_RECORDING_START_DATE', payload);
    },

    setRecordingEndDate({commit}, payload) {
        commit('SET_RECORDING_END_DATE', payload);
    },

    setRecords({commit}, payload) {
        commit('SET_RECORDS', payload);
    },

    setUserList({commit}, payload) {
        commit('SET_USERLIST', payload);
    },

    setRecordingMonths({commit}, payload) {
        commit('SET_RECORDING_MONTHS', payload);
    },

    setCategoryActive({commit}, payload) {
        commit('SET_CATEGORY_ACTIVE', payload);
    },

    setStatisticFilterButtons({commit}, payload) {
        commit('SET_STATISTIC_FILTER_BUTTONS', payload);
    },

}

const getters = {

    userList: state => state.userList,
    userListById2: state => user_id => state.userList.find(user => user.user_id === user_id),

    userListById(user_id) {

        console.log(user_id);

        let userList = state.userList;

        Object.keys(userList).forEach(el => {
            console.log(el, userList[el].user_id);
        });

    },

    getUserList() {
        return state.userList;
    },
    getMainCategories() {
        return state.main_categories;
    },
    getSubCategories() {
        return state.sub_categories;
    },

    getRecordingDates() {
        return state.recordingDates;
    },
    getRecordingYears() {
        return state.recordingYears;
    },
    getRecordingStartDate() {
        return state.recordingStartDate;
    },
    getRecordingEndDate() {
        return state.recordingEndDate;
    },
    getRecords() {
        return state.records;
    },
    getRecordingMonths() {
        return state.recordingMonths;
    },

    getStatisticFilterButtons() {
        return state.statisticFilterButtons;
    },


}

const userList = {
    state,
    mutations,
    actions,
    getters

}

export default userList;